import React from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import TimePicker from "react-bootstrap-time-picker";
import Select from "react-select";
import moment from "moment";
import { timeFromInt } from "time-number";
import { TIME_OPTIONS } from "../../components/contstants/AppointmentConstants";

/**
 * Card content for slotting weekday (RMV/Granite) students into group time slots.
 * Includes renderUnslottedStudentTimes as an internal helper.
 * Only renders when activeKey === "slotStudents".
 */
export default function WeekdaySlotStudentsCard({
  activeKey,
  selectedWeekday,
  dayOfExam,
  unsavedManuallyAddedStudents,
  unslotedGroupTimes,
  selectedTimeSlot,
  slotTime,
  startTime,
  endTime,
  unslotedMembers,
  loading,

  // callbacks
  onAddNewStudents,
  onSlotDurationChange,
  onStartTimeChange,
  onEndTimeChange,
  onGenerateUnslottedGroupTimes,
  onUnslottedTimeSave,
  onUnslottedStudentPick,
  onSubtractUnslottedTime,
}) {
  if (activeKey !== "slotStudents") {
    return null;
  }

  function renderUnslottedStudentTimes() {
    let timesToStudentMap = new Map();
    let studentsWithoutSlots = [];

    for (let i = 0; i < unslotedMembers.length; i++) {
      var student = unslotedMembers[i];
      if (student.hasOwnProperty("unslotTime")) {
        var slotName = student.unslotTime;
        if (timesToStudentMap.has(slotName)) {
          var existingStudents = timesToStudentMap.get(slotName);
          existingStudents.push(student);
          timesToStudentMap.set(slotName, existingStudents);
        } else {
          timesToStudentMap.set(slotName, [student]);
        }
      } else studentsWithoutSlots.push(student);
    }

    return (
      <div>
        {studentsWithoutSlots.length > 0 ? (
          <div>
            There{" "}
            {studentsWithoutSlots.length === 1 ? (
              <span>is</span>
            ) : (
              <span>are</span>
            )}{" "}
            {studentsWithoutSlots.length} student
            {studentsWithoutSlots.length === 1 ? null : "s"} remaining.{" "}
          </div>
        ) : (
          <div>Looks like all students have been slotted.</div>
        )}
        {unslotedGroupTimes.length === 0 ? (
          <div>
            There are currently no slots. Please generate some to start filling
            in students.
          </div>
        ) : (
          <div>
            <Table striped bordered hover responsive size="sm">
              <thead>
                <tr>
                  <th className="col-1">Time</th>
                  <th className="col-6">Students</th>
                  <th className="col-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {unslotedGroupTimes
                  .map((x) => x.slotName)
                  .map((time, index) => {
                    if (timesToStudentMap.has(time)) {
                      return (
                        <tr key={time}>
                          <td className="col-1">{time}</td>
                          <td className="col-6">
                            {" "}
                            Selected Student
                            <Select
                              isMulti
                              value={timesToStudentMap
                                .get(time)
                                .map((student) => ({
                                  label: student.fName + " " + student.lName,
                                  value: student,
                                }))}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              onChange={(data) =>
                                onUnslottedStudentPick(data, time, index)
                              }
                              options={studentsWithoutSlots.map(function (y) {
                                return {
                                  value: y,
                                  label: y.fName + " " + y.lName,
                                };
                              })}
                            />
                          </td>
                          <td>
                            <Button
                              variant="danger"
                              disabled={loading === true}
                              onClick={() => onSubtractUnslottedTime(time)}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      );
                    } else {
                      return (
                        <tr key={time}>
                          <td className="col-1">{time}</td>
                          <td className="col-6">
                            {" "}
                            Selected Student
                            <Select
                              isMulti
                              value={[]}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              onChange={(data) =>
                                onUnslottedStudentPick(data, time, index)
                              }
                              options={studentsWithoutSlots.map(function (y) {
                                return {
                                  value: y,
                                  label: y.fName + " " + y.lName,
                                };
                              })}
                            />
                          </td>
                          <td>
                            <Button
                              variant="danger"
                              onClick={() => onSubtractUnslottedTime(time)}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      );
                    }
                  })}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <div>
        <div>
          {unsavedManuallyAddedStudents.length > 0 ? (
            <div>
              <div>
                Warning. You have unsaved manually added students from
                earlier. Please save these students first.
              </div>
              <Button
                className="padLeft"
                variant="success"
                onClick={onAddNewStudents}
              >
                Save New Students
              </Button>
            </div>
          ) : null}

          {unslotedGroupTimes.length === 0 ? null : (
            <div>
              {" "}
              <div>Selected Groups Duration</div>
              {unslotedGroupTimes.map((selectedGroupTime) => {
                return (
                  <Button
                    key={selectedGroupTime.slotName}
                    size="sm"
                    variant="info"
                  >
                    {selectedGroupTime.slotName}
                  </Button>
                );
              })}
            </div>
          )}

          <div>Select Duration of Each Slot</div>
          <Select
            value={selectedTimeSlot}
            onChange={(data) => onSlotDurationChange(data)}
            options={TIME_OPTIONS}
          />
          <br></br>

          <div>
            Generate/View Slots for{" "}
            {moment(dayOfExam).format("dddd, MMMM Do YYYY")}
          </div>
          <br></br>
          <Row>
            <Col>
              <TimePicker
                start="5:00"
                end="21:00"
                step={slotTime}
                onChange={onStartTimeChange}
                value={startTime}
              />
            </Col>
            <Col sm={1}>to</Col>
            <Col>
              <TimePicker
                start={timeFromInt(
                  parseInt(startTime) + 60 * slotTime,
                )}
                end="21:00"
                step={slotTime}
                onChange={onEndTimeChange}
                value={endTime}
              />
            </Col>
          </Row>
          <br></br>
          <Button
            className="padLeft"
            onClick={onGenerateUnslottedGroupTimes}
          >
            Generate Group Time Slots
          </Button>

          {renderUnslottedStudentTimes()}
        </div>

        <div>
          <Button
            variant="primary"
            className="padLeft"
            disabled={loading || selectedWeekday.length === 0}
            onClick={onUnslottedTimeSave}
          >
            {" "}
            Save Slots{" "}
          </Button>

          {selectedWeekday ? null : (
            <div>Please Confirm Day of Week for Exam First</div>
          )}
        </div>
      </div>
    </div>
  );
}
